import "./App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Homepage from "./Homepage/Homepage";
import About_Us from "./components/About/About";
import Sridhar from "./People_Pages/Sridhar";
import Sujay from "./People_Pages/Sujay";
import Eeshan from "./People_Pages/Eeshan";
import Chaitra from "./People_Pages/Chaitra";
import Yogesh from "./People_Pages/Yogesh";
import Karthik from "./People_Pages/Karthik";
import Tejas from "./People_Pages/Tejas";
import Neha from "./People_Pages/Neha";
import Leenashri from "./People_Pages/Leenashri";
import Terms_of_Services from "./components/Terms_of_Services/Terms_of_Services";
import Privacy_Policy from "./components/Privacy_Policy/Privacy_Policy";
import Privacy_Policy_DPDP from "./components/Privacy_Policy_DPDP/Privacy_Policy_DPDP";
import Media_Community_Policy from "./components/Media_Community_Policy/Media_Community_Policy";
import Login from "./pages/Login";
import OAuthCallback from "./pages/OAuthCallback";
import DeleteAccount from "./pages/DeleteAccount";
import AccountDeleted from "./pages/AccountDeleted";
import DownloadApp from "./pages/DownloadApp";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Homepage />} />
        <Route path="/About_Us" element={<About_Us />} />
        <Route path="/Sridhar" element={<Sridhar />} />
        <Route path="/Sujay" element={<Sujay />} />
        <Route path="/Eeshan" element={<Eeshan />} />
        <Route path="/Chaitra" element={<Chaitra />} />
        <Route path="/Yogesh" element={<Yogesh />} />
        <Route path="/Karthik" element={<Karthik />} />
        <Route path="/Tejas" element={<Tejas />} />
        <Route path="/Neha" element={<Neha />} />
        <Route path="/Leena" element={<Leenashri />} />
        <Route path="/Terms_of_use" element={<Terms_of_Services />} />
        <Route path="/Privacy_Policy" element={<Privacy_Policy_DPDP />} />
        <Route path="/Copyright_music_policy" element={<Privacy_Policy />} />
        <Route
          path="/Boloindia_Community_Guidelines"
          element={<Media_Community_Policy />}
        />

        <Route path="/Login" element={<Login />} />
        <Route path="/auth/callback/:provider" element={<OAuthCallback />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/account-deleted" element={<AccountDeleted />} />
        <Route path="/download-app" element={<DownloadApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />

        {/* <Route path="/app/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/app/deleterequest" element={<DeleteAccount />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
